import { Action, ActionTemplate, any, do_anything, do_nothing } from 'apprise-core/action';
import { User } from 'apprise-core/user';
import { FormState } from 'apprise-frontend-core/utils/form';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';
import { PermissionBoxProps } from 'apprise-frontend-iam/permission/permissionbox';
import { useRegisteredUserPermissionModules, useRegisteredUserPreferenceModules } from 'apprise-frontend-iam/user/users';
import { SheetWriter } from 'apprise-frontend-parse/workbookWriter';
import { Fields } from 'apprise-ui/field/validation';
import React, { FC } from 'react';
import { IconBaseProps } from 'react-icons';
import { DownloadOptions } from './download';

export type UserPreferencesModule = {

    Form: FC<FormState<User>>
    fields?: (_: FormState<User>) => Fields
    columns?: JSX.Element[]
    download?: (_: SheetWriter<User>, __: DownloadOptions) => void
    
}


export const useUserPreferencesModules = () => {

    const state = useRegisteredUserPreferenceModules()

    const self = {

        all: () => state.get().modules

        ,

        register: (module: UserPreferencesModule) => state.set(s => s.modules = [...s.modules, module])

    }


    return self
}


export type UserPermissionBoxProps<R = any> = Partial<PermissionBoxProps<R>> & {

    edited: User
}




// attaches management info to a template
export type ActionDefinition = ActionTemplate & {  

    name: string
    shortName?: string
    icon?: JSX.Element
    description: string
    virtual?: boolean
    width?: string | number

}

/* ----------------------------- */
export type UserPermissionModule<R> = {

    // presentation
    type: string
    plural: string
    Icon: React.FC<IconBaseProps>

    actionType?: ActionTemplate['actionType']
    
    
    actions: ActionDefinition[]
    initial?: (_: User) => Action[]                             // note: currently added on save.
    maxPrivilege?: Action                                       // used to refine the UI (disables Add More...)
    
    
   
    renderIf? : (edited: User) => boolean                       // skip for given user? (note: since 08/25 use actionType='admin' to disable for tenant users.)
    Box: (_: UserPermissionBoxProps<R>) => JSX.Element           

}


export const do_anything_definition: ActionDefinition =  { ...do_anything,  name: "authz.do_anything_name", description: "authz.do_anything_description",}
export const do_nothing_definition: ActionDefinition =  { ...do_nothing, name: "authz.do_nothing_name", description: "authz.do_nothing_description"}



export const useUserPermissionModules = () => {

    const state = useRegisteredUserPermissionModules()
    const oracle = useOracle()
    
    const self = {

        all: () => state?.get().modules

        ,


        allActions: () => [do_anything_definition, do_nothing_definition, ...self.all().flatMap( m => m.actions) ?? []]

        ,

        register: (module: UserPermissionModule<any>) => state.set(s =>{

            const idx = s.modules.findIndex(m => m.type === module.type)
            idx !== -1 ? s.modules[idx] = module : s.modules.push(module)

        }) 

        ,

        initial: (user: User) => {
        
            const useroracle = oracle.given(user)
            
            // filter for user type and make sure they have a resource, possibly any
            return self.all().filter(useroracle.isFor).flatMap(m => m.initial?.(user) ?? []).map(a => ({...a, resource: a.resource ?? any})) ?? []
        
        }

    }

    return self;
}